import React from "react";
import { Autocomplete, TextField } from "@mui/material";

/**
 * students: [{ id, name }]
 * value: array of selected student ids
 * onChange: (ids[]) => void
 */
const StudentAutocomplete = ({ students = [], value = [], onChange }) => {
  return (
    <Autocomplete
      multiple
      options={students}
      getOptionLabel={(option) => option.name}
      value={students.filter((s) => value.includes(s.id))}
      onChange={(_, newValue) => {
        onChange(newValue.map((s) => s.id));
      }}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Search students…"
        />
      )}
      sx={{
        "& .MuiChip-root": {
          borderRadius: "12px",
        },
      }}
    />
  );
};

export default StudentAutocomplete;
